export default Object.freeze({
  Unspecified: 0,
  AppRegistration: 1,
  PlatformOAuth: 2,
});
